import { Box, TextField } from "@radix-ui/themes";
import { Control, Controller, FieldErrors } from "react-hook-form";
import { formatDateForInput } from "../../../utils/dateFormatter";
import {
  ComposedName,
  FieldShell,
  fieldAria,
  fieldIds,
  resolveFieldError,
} from "../FieldShell";

interface DateFieldProps {
  name: string;
  label: string;
  control: Control<any>;
  errors: FieldErrors<any>;
  style?: any;
  fieldProps?: any;
  composedName?: ComposedName;
  required?: boolean;
  hint?: string;
}

const DateFieldComponent = ({
  name,
  label,
  control,
  errors,
  style,
  fieldProps,
  composedName,
  required,
  hint,
}: DateFieldProps) => {
  const error = resolveFieldError(errors, name, composedName);
  const { fieldId } = fieldIds(name);

  return (
    <Box {...style}>
      <FieldShell name={name} label={label} required={required} error={error} hint={hint}>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <TextField.Root
              size="2"
              type="date"
              id={fieldId}
              color={error ? "red" : undefined}
              {...fieldAria(name, error, hint)}
              {...field}
              {...fieldProps}
              value={formatDateForInput(field.value)}
            />
          )}
        />
      </FieldShell>
    </Box>
  );
};

export default DateFieldComponent;
